module.exports = __webpack_public_path__ + "static/media/19ESCAP6.1842681a.jpg";